<script setup>

import {Modal} from "momentum-modal";
import Notifications from "./Components/Notifications.vue";
import ClientOnly from "@duannx/vue-client-only";
import {Link} from "@inertiajs/vue3";
import UserMenuLarge from "./Components/UserMenuLarge.vue";
</script>

<template>
    <div class="w-full bg-[rgba(8,13,39,1)]">
        <!-- top menu -->
        <div class="h-14 md:h-16 lg:h-22 py-1 px-6 md:px-8 sticky top-0 flex items-center justify-between bg-gradient-to-b from-[rgba(8,13,39,1)] z-50">
            <slot name="title" />

            <div class="shrink-0">
                <UserMenuLarge v-if="$page.props.auth.user" class="hidden lg:block" />
                <div v-else class="ml-10 space-x-5 hidden lg:block">
                    <Link :href="`/auth/signin`" preserve-state :data="{ from: $page.url }" class="text-[rgba(235,248,255,1)] text-sm">
                        Sign in
                    </Link>

                    <Link :href="`/auth/register`" :data="{ from: $page.url }" preserve-state class="bg-[#41FBDC] rounded-full px-3 py-1.5 text-[rgba(20, 22, 57, 1)] text-sm drop-shadow-[0px_2px_6px_rgba(26,188,151,0.5)]">
                        Get started
                    </Link>
                </div>
            </div>
        </div>
        <div class="flex items-start w-full xl:pr-[360px] 2xl:pr-[400px]">
            <div class="px-6 space-y-8 grow pb-8 min-h-0 w-full">
               <slot />
            </div>
        </div>
    </div>

    <ClientOnly>
        <Modal />
        <Notifications />
    </ClientOnly>
</template>
